import { FormField } from '../form-builder/form-field.model';
import { FormFieldBaseComponent } from '../../components/form-fields/form-field-base/form-field-base.component';

// Define a class used to keep track of context menu data.
export class GridCellContextMenuInfo {
    public mouseEvent: MouseEvent;

    public columnDef: FormField = null;
    public component: FormFieldBaseComponent = null;

    public contextMenuXPos: string = null;
    public contextMenuYPos: string = null;
}

